import { LabelProviders } from '@shipstation/client-common/constants/label-providers';

export const isUpsInvoicedShippingServiceProvider = (shippingServiceProviderId: string) => {
  return !!shippingServiceProviderId && shippingServiceProviderId === LabelProviders.UpsInvoiced;
};
